import { render, staticRenderFns } from "./AllergenSettingPage.vue?vue&type=template&id=f5cee8c2&"
import script from "./AllergenSettingPage.vue?vue&type=script&lang=js&"
export * from "./AllergenSettingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports